import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import OfferPresentationCardPreview from "@project/components/OfferPresentationCard/OfferPresentationCardPreview";
export const OfferPresentationCard = {
    label: "Carte de presentation offre",
    type: ContentsCustomTypes.OFFER_PRESENTATION_CARD,
    Preview: OfferPresentationCardPreview,
    editionModal: true,
    icon: "address-card",
    editionModalPosition: "top",
    children: [
        {
            label: "Couleur",
            key: "barColor",
            type: ContentsTypes.COLOR,
            value: "#0CFFC6",
        },
        {
            label: "Sur-titre",
            key: "surtitle",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Carte prix",
            key: "isPriceCard",
            type: ContentsTypes.CHECKBOX,
            value: "false",
        },
        {
            label: "Complément titre",
            key: "titleComplement",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Titre caractéristiques",
            key: "titleFeatures",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Caracteristiques",
            key: "features",
            type: ContentsTypes.TEXT,
            value: "",
        },
        {
            label: "Liste avec éléments optionnels",
            key: "featuresOptional",
            type: ContentsTypes.CHECKBOX,
            value: "",
        },
        {
            label: "Avantage inclus",
            key: "plusFeature",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Icone avantage inclus",
            key: "plusFeatureIcon",
            type: ContentsTypes.ICON,
            value: "",
        },
    ],
};
